module.exports = __webpack_public_path__ + "img/pink_dot.ca016164.svg";